import Transform from '@ember-data/serializer/transform';
import LegacyMoneyUtils from '@square/dashboard-data/utils/legacy-money';
export default class LegacyMoney extends Transform {
  deserialize(hash) {
    return LegacyMoneyUtils.deserialize(hash);
  }
  serialize(money) {
    return LegacyMoneyUtils.serialize(money);
  }
}